import { IAppState } from 'shared/common/state';

export const btpFlightRkActivityReducer = (state: IAppState): IAppState => {
  return {
    ...state,
    btpFlightRkActive: state.btpFlightRkActive,
  };
};
